import React from "react";
import { Link } from "react-router-dom";

const Card2 = ({ article }) => {
  return (
    <Link to={`/article/${article.slug}`}>
      <div class="max-w-lg mx-auto">
        <div class="bg-white mx-2 border-gray-200 max-w-sm">
          <div class="p-5 font-poppins">
            <a href="#">
              <h5
                id="title"
                class="text-gray-900 font-bold text-2xl tracking-tight mb-2"
              >
                {article.title}
              </h5>
            </a>
            <p className="text-right text-gray-400 mb-4">
              Posted {article.published}
            </p>
            <p id="description" class="font-normal text-gray-700 mb-3">
              {article.description}
            </p>
            <a
              class="text-main-color underline hover:text-black focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm py-2 text-center inline-flex items-center"
              href="#"
            >
              Read in 3 minutes
            </a>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Card2;
